module.exports = __webpack_public_path__ + "static/media/air-filter-change.cfb58d80.svg";